<template>
  <v-banner
    v-if="showUpdateBanner"
    color="primary"
    dark
    class="version-update-banner"
    elevation="2"
    single-line
  >
    <v-icon slot="icon" color="white" size="20">
      mdi-update
    </v-icon>
    
    <div class="banner-content">
      <span class="banner-text">
        There's a new version available
      </span>
      
      <v-btn
        color="white"
        text
        x-small
        @click="reloadApp"
        class="ml-4"
      >
        Reload
      </v-btn>
    </div>
  </v-banner>
</template>

<script>
import { mapState } from 'vuex'
import { getFirestore, doc, getDoc } from 'firebase/firestore'

export default {
  name: 'VersionUpdateNotification',
  computed: {
    ...mapState('app', ['showUpdateBanner'])
  },
  methods: {
    reloadApp() {
      // Get the remote version from Firestore and update local version before reload
      getDoc(doc(getFirestore(), 'config', 'app_version'))
        .then(d => {
          if (d.exists()) {
            const remoteVersion = d.data().version
            localStorage.setItem('app_version', remoteVersion)
            console.log(`Updated local version to: ${remoteVersion}`)
          }
        })
        .catch(error => {
          console.warn('Error updating version before reload:', error)
        })
        .finally(() => {
          // Clear cache and reload
          if ('caches' in window) {
            caches.keys().then(names => {
              names.forEach(name => {
                caches.delete(name)
              })
            }).then(() => {
              window.location.reload(true)
            })
          } else {
            window.location.reload(true)
          }
        })
    }
  }
}
</script>

<style scoped>
.version-update-banner {
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 10000 !important;
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.banner-text {
  font-weight: 500;
  font-size: 14px;
}
</style>
